import { z } from 'zod'

/** Opaque source-result fingerprint, not an audit trail or a persistent formula version. */
export const editBaseRevisionSchema = z.string().regex(/^[0-9a-f]{64}$/)
export const EDIT_CONFLICT_CODE = 'EDIT_CONFLICT' as const
export const EDIT_SOURCE_UNAVAILABLE_CODE = 'EDIT_SOURCE_UNAVAILABLE' as const

export function editBaseRevision(value: unknown): string | null {
  const parsed = editBaseRevisionSchema.safeParse(value)
  return parsed.success ? parsed.data : null
}
